import React from 'react'
import { useDocumentTitle } from '@mantine/hooks'
import { useTranslation } from 'react-i18next'
import { Box, Button, Link } from '@node-space/ui-components'
import { AppStatus } from 'components/layout/AppStatus'
import { ExternalLinks } from 'constants/links'
import { VerificationRequestStatus, VerificationStatuses } from 'types/verification'
import { logout } from 'utils/utils'

export const ApplicationOnboarding = ({
  verificationRequestStatus,
}: {
  verificationRequestStatus: VerificationRequestStatus
}) => {
  const isPending = verificationRequestStatus === VerificationStatuses.PENDING
  const tabTitle = isPending ? 'Application Pending' : 'Application Not Submitted'
  useDocumentTitle(`${process.env.SITE_TITLE} | ${tabTitle}`)
  const { t } = useTranslation()

  const translationKey = isPending ? 'applicationPending' : 'applicationNotSubmitted'

  return (
    <AppStatus animationName="not-verified" title={t(`${translationKey}.title`)}>
      <p>
        {t(`${translationKey}.description`)}
        <Link href={ExternalLinks.CONTACT_SUPPORT ?? ''} target="_blank">
          {t('errorMessages.contactSupport')}
        </Link>
        .
      </p>
      <Box paddingT={12}>
        <Button onClick={logout}>{t('logOut')}</Button>
      </Box>
    </AppStatus>
  )
}
